<div class="report-optimisation-overview-container">
    <slot/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro-erp.less";

    .report-optimisation-overview-container {
        .flex-grow();
        position: relative;
        gap: @spacing-xxl;
    }
</style>